import { useQueryClient } from '@tanstack/react-query'
import { useCallback } from 'react'
import { apiClient } from '~/shared/api/data-ingestion-api'
import { useAddClassificationReview } from './use-add-classification-review'

export function useSubmitClassificationNotes({ documentKey }: { documentKey: string }) {
  const queryClient = useQueryClient()

  const {
    mutateAsync: addClassificationReview,
    isPending,
    isSuccess,
  } = useAddClassificationReview({
    onSuccess: () => {
      queryClient.invalidateQueries(
        apiClient.getDocumentClassificationReviewDocumentsKeyClassificationReviewsGetOptions({
          path: {
            key: documentKey,
          },
        }),
      )
    },
  })

  const submitClassificationNotes = useCallback(
    async (classificationReview: apiClient.DocumentClassificationReviewCreateRequest) => {
      await addClassificationReview({
        path: {
          key: documentKey,
        },
        body: classificationReview,
      })
    },
    [addClassificationReview, documentKey],
  )

  return {
    submitClassificationNotes,
    isPending,
    isSuccess,
  }
}
